
const defaultOptions = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
};

export function formatCentToUsd (value, options = defaultOptions) {
    const dollarValue = Number(value || 0) / 100;
    return Intl.NumberFormat('en', options).format(dollarValue);
}


// WEBPACK FOOTER //
// ./src/app/components/bannerV2/helpers.js